export enum FieldWrapperType {
  CHECKLIST = "checklist",
  APPLICATION = "application",
}
